import { mdiArrowLeft, mdiDelete, mdiDotsVertical, mdiDownload } from '@mdi/js'
import MyLists from '@/components/MyLists'
import Share from '@/components/Share.vue'
import ConfirmDeleteModal from '@/components/ConfirmDeleteModal'
import ConfirmExportListModal from '@/components/ConfirmExportListModal'
import contentApi from '@/api/content'
import firebase from '@/api/firebase'
import Const from '@/helpers/const'
import { jsPDF } from 'jspdf'
export default {
  name: 'MyLists',
  components: {
    'myLists': MyLists,
    'share': Share,
    ConfirmDeleteModal,
    ConfirmExportListModal,
  },
  data: () => {
    return {
      length: 1,
      tab: null,
      mdiArrowLeft, mdiDelete, mdiDotsVertical, mdiDownload,
      user: null,
      previousRoute: null,
      lists: [],
      createNewListBtn: true,
      exportListBtn: true,
      downloadListBtn: true,
      listName: '',
      experiences: [],
      experiences3D: [],
      experiencesLabs: [],
      experiences360: [],
      showProgressCircular :false,
      typesExperience: ['360', 'LABS', '3D'],
      toastOptions: {
        position: 'bottom-center',
        duration: 3000,
      },
      currentListOptions: [
        'Exportar esta lista', // 'Adicionar lista', 'Remover lista'
      ],
      expansionPanelOpen: [0, 1, 2]
    }
  },
  computed: {
    getInstallerUrl () {
      // Returns ambia's installer link to the authorized user
      return Const.AWS_CONFIG().ambiaInstallerUrl
    },
  },
  async created () {
    // TODO: this needs to get away ASAP. For that, we want to get the
    // mapActions, mapGetters in place:
    // https://dev.azure.com/GrupoA-Edtech/Edtech/_backlogs/backlog/Imersys%20-%20Web/Epics/?workitem=7221
    this.showProgressCircular = true
    await this.getUserByEmail()
    await this.getUserData()
    if (this.user.lists && this.user.lists.length > 0) {
      await this.populateExperiences()
      this.organizeExperiencesByType()
    }
    this.showProgressCircular = false
  },
  mounted () {
    this.$bus.$on('update-xp-list', () => {
      if (this.user.lists.length){
        let index = this.user.lists.length - 1
        this.updateUserListXP(index)
      }
    })
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from.fullPath
    })
  },
  methods: {
    async getUserByEmail () {
      let vm = this
      let params = {
        'userEmail': JSON.parse(localStorage.getItem('user')).email
      }
      let userForEmail = await firebase.getUserByEmail(params)
      userForEmail.forEach(
        await function (doc) {
          vm.user = {}
          vm.user.uid = doc.id
          vm.user.role = doc.data().role
          vm.user.institution = doc.data().institution
          vm.user.email = doc.data().email
          vm.user.displayName = JSON.parse(localStorage.getItem('user')).displayName
        }
      )
    },
    async getUserData () {
      let vm = this
      let experiences = []
      let i = 0
      let params = {
        'userId': this.user.uid
      }

      let data = await firebase.getUserLists(params)
      data.forEach(
        await function (doc) {
          experiences.push(doc.data())
            experiences[i].name = doc.id
          vm.user.lists = experiences
          i += 1
        }
      )

    },
    changeToLastRoute () {
      this.$router.push({ path: this.previousRoute })
    },
    organizeExperiencesByType () {
      for (let i = 0; i < this.experiences.length; i++) {
        if (this.experiences[i].type === '360') this.experiences360.push(this.experiences[i])
        if (this.experiences[i].type === 'labs') this.experiencesLabs.push(this.experiences[i])
        if (this.experiences[i].type === '3d') this.experiences3D.push(this.experiences[i])
      }
    },
    deleteFromUserList(indexExperience, type, listName) {
      if(type === '360'){
        this.$refs.myLists[indexExperience].deleteFromUserList(listName)
        this.experiences360.splice(indexExperience, 1)
      }
      if(type === 'LABS'){
        let index = indexExperience + this.experiences360.length
        this.$refs.myLists[index].deleteFromUserList(listName)
        this.experiencesLabs.splice(indexExperience, 1)
      }
      if(type === '3D'){
        let index = indexExperience + this.experiences360.length + this.experiencesLabs.length
        this.$refs.myLists[index].deleteFromUserList(listName)
        this.experiences3D.splice(indexExperience, 1)
      }
    },

    downloadMessage() {
      let text = 'Por favor, envie um email para contato@imersys.com para ter acesso'
      this.$toasted.clear()
      this.$toasted.show(text, this.toastOptions)
    },

    isUserAuthorized () {
      // By default we prohibit 'democatalogo' user (the "salesman user") to
      // fetch the keys to be used within the LMS. This is an workaround scheme
      // for authorization.
      return this.user.email !== 'democatalogo@imersys.com' && this.user.displayName !== 'democatalogo'
        && this.user.role !== 'guest'
    },

    populateExperiences () {
      // TODO: this is quite expensive cause we are issuing one request per experience. We need to
      // think ways to maybe batch the requests or other cheaper ways to achieve the results here.
      let vm = this
      return Promise.all(vm.user.lists.map(list => {
        return Promise.all(list.experiences.map(id =>
          contentApi.getLearningObjectById(id)
        ))
        .then(experiences => ({
          name: list.name,
          experiences
        }))
        .catch(e => {
          console.error(e)
        })
      }))
      .then(lists => {
        vm.lists = vm.user.lists = lists
        vm.experiences = vm.lists[0].experiences
      })
    },
    updateUserListXP (index) {
      this.experiences = this.lists[index].experiences
      this.experiences360 = []
      this.experiences3D = []
      this.experiencesLabs = []
      this.organizeExperiencesByType()
    },

    getVideoId(xp) {
      try {
        // Return the URL of the first content inside the Learning Object
        let firstContentId = xp.sortedContentIds[0]
        let firstContent = xp.contents.items.find(item =>
          item.id === firstContentId
        )
        let url = firstContent.content.url
        if (url.indexOf('/') >= 0)
          return url.split('/').pop() || ''
        return ''
      } catch (error) {
        console.error(error)
        return ''
      }
    },

    clearTextField() {
      this.listName = ''
    },

    createUserList(listName) {
      let experiences = []
      let params = {
        'id': this.user.uid,
        'listName': listName
      }
      let listProp = {
        'name': params.listName,
        'experiences': experiences
      }
      if(params.listName){
        let course = {}
        if (!this.user.lists) {
          course = [listProp]
          this.user.lists = (course)
          this.lists = (course)
        } else {
          course = listProp
          this.user.lists.push(course)
          this.user.lists.sort((a, b) => (a.name > b.name) ? 1 : -1)
          this.lists = this.user.lists
        }
        firebase.createUserList(params)
      }
    },
    downloadListPdf(listName) {

      let xpYPosition = 60
      let xpLink
      let xpDescription
      let userInstitution = this.user.institution.charAt(0).toUpperCase() + this.user.institution.slice(1)
      const pdf = new jsPDF()

      let imersys_header = new Image()
      imersys_header.src = require('@/assets/imgs/imersys_header.jpeg')
      pdf.addImage(imersys_header, 'JPEG', 0, 0, 215, 15)

      pdf.setFontSize(16)
      pdf.text('Instituição: ' + userInstitution, 10, 25)
      pdf.text('Usuário: ' + this.user.email, 10, 30)

      if(this.experiences360.length > 0){
        pdf.setFontSize(18)
        pdf.text(listName + ' - Experiências 360', 10, 50)
        pdf.setFontSize(10)
        pdf.setTextColor(0,0,238)

        this.experiences360.forEach(xp => {
          xpLink = 'https://lms.imersys.com/?ua=' + this.getVideoId(xp)
          xpDescription = xp.title + ' - ' + xpLink
          pdf.textWithLink(xpDescription, 10, xpYPosition, { url: xpLink, maxWidth: 150 })
          xpYPosition += 12
          if (xpYPosition >= 290){
            pdf.addPage()
            pdf.addImage(imersys_header, 'JPEG', 0, 0, 215, 15)
            xpYPosition = 20
          }
        })
      }

      if(this.experiences3D.length > 0){
        pdf.setFontSize(18)
        pdf.setTextColor(0, 0, 0)
        pdf.text(listName + ' - Realidade Aumentada', 10, xpYPosition)
        xpYPosition += 12
        if (xpYPosition >= 290){
          pdf.addPage()
          pdf.addImage(imersys_header, 'JPEG', 0, 0, 215, 15)
          xpYPosition = 20
        }
        pdf.setFontSize(10)
        pdf.setTextColor(0,0,238)

        this.experiences3D.forEach(xp => {
          xpLink = 'https://lms.imersys.com/?viewer=' + xp.id
          xpDescription = xp.title + ' - ' + xpLink
          pdf.textWithLink(xpDescription, 10, xpYPosition, { url: xpLink, maxWidth: 150 })
          xpYPosition += 12
          if (xpYPosition >= 290){
            pdf.addPage()
            pdf.addImage(imersys_header, 'JPEG', 0, 0, 215, 15)
            xpYPosition = 20
          }
        })
      }

      pdf.save(listName + '.pdf')
    },
    redirectToLink(xp, type) {
      if (type == '360'){
        let id = this.getVideoId(xp)
        return 'https://player.imersys.com/video/' + id
      }else
        return 'http://viewer.imersys.com/lo/' + xp.id
    },
    focusOut() {
      this.createNewListBtn = true
    }
  },

  watch: {
    length (val) {
      this.tab = val - 1
    },
  },

  beforeDestroy () {
  }
}
